
import { Branch } from '../base/branch';
import { Node } from '../base/node';
import { Club } from './club';

export class Client extends Node {
    static _type: string = 'Client';
    i_client: true = true;

    clientId?: string;
    secret?: string;

    constructor(source?: any) {
        super(source);

        if (source) {
            this.clientId = source.clientId;
            this.secret = source.secret;
        }
    }

    copy(source?: any) {
        super.copy(source);

        if (source) {
            this.clientId = source.clientId;
            this.secret = source.secret;
        }
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Club;
    }
}
